import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import watermark2 from '../images /watermark2.png';

const Help = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [status, setStatus] = useState({ success: null, message: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceId = 'service_sepfri1539'; 
    const templateId = 'template_frisept201554'; 
    const publicKey = 'DeeyWGcO3WVXJ-uDJ'; 

    emailjs.send(serviceId, templateId, formData, publicKey)
      .then(() => {
        setStatus({ success: true, message: '✅ Message sent successfully! I will get back to you soon.' });
        setFormData({ name: '', email: '', message: '' }); // Reset form
      })
      .catch(() => {
        setStatus({ success: false, message: '❌ Failed to send message. Please try again later.' });
      });
  };

  return (
    <div className="help-container">
      <h1>Need Help? Contact Us</h1>
      <p>Have a question, issue, or feedback? Reach out below!</p>

      <div className="watermark">
        <img src={watermark2} alt="Watermark" />
      </div>

      <form className="contact-form" onSubmit={handleSubmit}>
        <div>
          <label>Name:</label>
          <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        </div>
        <div>
          <label>Email:</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        </div>
        <div>
          <label>Message:</label>
          <textarea name="message" value={formData.message} onChange={handleChange} required placeholder="How can we assist you?"></textarea>
        </div>
        <button type="submit">Send Message</button>

        {status.message && (
          <p className={status.success ? 'success-message' : 'error-message'}>
            {status.message}
          </p>
        )}
      </form>
    </div>
  );
};

export default Help;
